import styled from "styled-components";

export default styled.div`
        position: fixed;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 88px;
        background-image: linear-gradient(to bottom, rgba(255, 255, 255, 0), #fff 17%);
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 10px;
    `